export interface HandoffCondition {
  id: string
  title: string
  summary: string
  prompt: string
}

export const handoffConditions: HandoffCondition[] = [
  {
    id: "human_agent",
    title: "When reaching a human agent",
    summary:
      "Automatically transfers when your AI connects with a live customer service representative, ensuring you can take over the conversation at the most critical moment.",
    prompt:
      "You must transfer the call immediately when you detect that a live human agent has joined the conversation. Indicators include: the person greets you and identifies themselves as a representative, or the menu options end and a person responds. When this happens, say 'One moment please, let me connect you with my client' and initiate the handoff transfer immediately."
  },
  {
    id: "off_hold",
    title: "When coming off of hold",
    summary:
      "Transfers the call when the person returns from being on hold, perfect for when you want to handle the continued conversation personally after waiting.",
    prompt:
      "You must transfer the call when you detect the human has returned from being placed on hold. Indicators include: the human saying 'thank you for holding' or 'sorry for the wait', or the human continuing the previous conversation. When this happens, say 'Thank you for coming back, let me connect you with my client now' and initiate the handoff transfer immediately."
  },
  {
    id: "personal_info",
    title: "When personal information is requested",
    summary:
      "Immediately transfers when sensitive information like SSN, account numbers, or passwords are requested, keeping your personal data secure.",
    prompt:
      "You must transfer the call immediately when the human requests any sensitive personal information. This includes but is not limited to: Social Security numbers, account numbers, passwords, PINs, credit card numbers, banking information, dates of birth for verification, or any other personally identifiable information. When this happens, say 'For security purposes, I need to connect you directly with my client' and initiate the handoff transfer immediately. Do not attempt to provide or discuss any personal information."
  }
]

export const getHandoffConditionById = (id: string): HandoffCondition | undefined => {
  return handoffConditions.find((condition) => condition.id === id)
}

export const getHandoffConditionByPrompt = (prompt: string): HandoffCondition | undefined => {
  return handoffConditions.find((condition) => condition.prompt === prompt)
}
